import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        root: {
            backgroundColor: theme.palette.background.paper,
            width: "100%",
            "&& header": {
                boxShadow: "none !important"
            }
        },
    }));
};
